import { toAbsoluteUrl } from '../../../../../../_start/helpers';
import { HomeHeader } from './HomeHeader';

type HomeFigureProps = {
  data: HomeHeader;
  update: (fieldsToUpdate: Partial<HomeHeader>) => void;
};

export const HomeFigure = ({ data, update }: HomeFigureProps) => {
  return (
    <div className="home-header__figure">
      {data.image ? (
        <div className="mt-5 overlay">
          <div className="overlay-wrapper">
            <img
              alt="dummy"
              src={data.image}
              style={{
                width: '100%',
                height: '625px',
                objectFit: 'cover',
              }}
            />
          </div>
          <div className="overlay-layer bg-dark bg-opacity-10 flex-column align-items-start ps-12">
            <div>
              <button
                name="image"
                className="btn btn-primary btn-shadow"
                onClick={() =>
                  update({
                    image: '',
                    image_alt: '',
                  })
                }
              >
                Remove
              </button>
              <label
                className="btn btn-light-primary btn-shadow ms-2"
                data-bs-toggle="modal"
                data-bs-target={`#${data.name}-${data.id}`}
              >
                Change
              </label>
            </div>

            <input
              placeholder="Alt attribute"
              className="w-25 mt-2 form-control form-control-lg form-control-solid"
              type="text"
              value={data.image_alt ?? ''}
              onChange={(event) => update({ image_alt: event.target.value })}
            />
          </div>
        </div>
      ) : (
        <>
          <label
            className="mt-5"
            data-bs-toggle="modal"
            data-bs-target={`#${data.name}-${data.id}`}
          >
            <img
              src={toAbsoluteUrl('/assets/images/1100x626.webp')}
              style={{
                width: '100%',
                height: '625px',
                objectFit: 'cover',
              }}
              alt=""
            />
          </label>
        </>
      )}
    </div>
  );
};
